import { useState, useEffect, useRef } from 'react';
import confetti from 'canvas-confetti';
import playSound from '../utils/playSound';

export const useConfettiText = (
  inputRef,
  mobileView,
  customText,
  particleCount = 200,
  parent,
  isVoiceMemo,
) => {
  const moneySound1 =
    'https://res.cloudinary.com/joegalaxy/video/upload/v1706507635/coin-and-money-bag-5-185266_eb67fk.mp3';
  const birthdaySound1 =
    'https://res.cloudinary.com/joegalaxy/video/upload/v1734158938/hApPy_BiRtHdAy_-_In_Da_Club_jfi2vm.mp3';
  const fireworksSound1 =
    'https://res.cloudinary.com/joegalaxy/video/upload/v1751253492/Firework_-_Sound_Effect_HD_kbrme0.mp3';

  const [showText, setShowText] = useState(false);
  const [bottom, setBottom] = useState('0px');
  const [left, setLeft] = useState('0px');
  const timeoutId = useRef(null);

  const getSeason = () => {
    const month = new Date().getMonth() + 1;
    if ([12, 1, 2].includes(month)) return 'winter';
    if ([3, 4, 5].includes(month)) return 'spring';
    if ([6, 7, 8].includes(month)) return 'summer';
    return 'fall';
  };

  const getConfettiPreset = (season) => {
    switch (season) {
      case 'summer':
        return {
          colors: ['#ff0043', '#ffffff', '#002fff', '#faff00'],
          sound: fireworksSound1,
        };
      case 'fall':
        return { colors: ['#FFA500', '#8B4513', '#FFD700'] };
      case 'winter':
        return { colors: ['#E0F7FA', '#FFFFFF', '#B2EBF2'] };
      case 'spring':
      default:
        return { colors: ['#00C853', '#FFD600', '#FF4081'] };
    }
  };

  const showConfettiText = () => {
    if (inputRef.current) {
      const rect = inputRef.current.getBoundingClientRect();
      const originX = rect.left + rect.width / 2;
      const originY = rect.top + rect.height / 2;
      const confettiOrigin = {
        x: originX / window.innerWidth,
        y: originY / window.innerHeight,
      };

      const bottomOffset = window.innerHeight - rect.bottom;
      setBottom(`${bottomOffset - 40}px`);
      setLeft(`${originX}px`);
      setShowText(true);

      const season = getSeason();
      const { colors, sound } = getConfettiPreset(season);
      console.log(`Confetti colors for ${season}:`, colors);
      if (season === 'summer') {
        for (let i = 0; i < 3; i++) {
          setTimeout(() => {
            confetti({
              particleCount: particleCount / 2,
              startVelocity: 45,
              spread: 360,
              scalar: 1.3,
              ticks: 120,
              origin: confettiOrigin,
              colors,
            });
          }, i * 250);
        }
      } else {
        confetti({
          particleCount,
          startVelocity: 30,
          spread: 360,
          ticks: 300,
          gravity: 0.6,
          origin: confettiOrigin,
          colors,
        });
      }

      const soundToPlay =
        parent === 'birthday' ? birthdaySound1 : sound || moneySound1;
      const durationSecs = parent === 'birthday' ? 13.7 : 4.8;

      playSound(soundToPlay, durationSecs);

      timeoutId.current = setTimeout(() => {
        setShowText(false);
      }, 3000);
    }
  };

  useEffect(() => {
    return () => clearTimeout(timeoutId.current);
  }, []);

  const ConfettiTextComponent = () => (
    <div
      style={{
        display: showText ? 'block' : 'none',
        color: '#8a2be2',
        fontSize: '13px',
        position: 'fixed',
        bottom,
        left,
        transform: 'translateX(-50%)',
        zIndex: 9999,
      }}
    >
      {customText || '+4 JGK Yeah!'}
    </div>
  );

  return [showConfettiText, ConfettiTextComponent];
};
